import { comics } from "@/mocks/comics";

const steps = [
  { icon: "ri-search-eye-line", title: "一键追更", desc: "在喜欢作品的详情页点「追更」，加入你的专属追更列表" },
  { icon: "ri-notification-badge-line", title: "更新即提醒", desc: "作品更新新章节时，第一时间推送通知，不错过任何一话" },
  { icon: "ri-calendar-check-line", title: "每日汇总", desc: "订阅每日更新提醒，把全部追更内容汇总成一份通知" },
];

export default function FeatureSection() {
  const featured = comics[0];
  return (
    <section id="feature" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 text-primary-700 px-3 py-1 text-xs">
              <i className="ri-notification-3-line"></i>核心功能
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">追更提醒，更新一个都不错过</h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              韩漫yy把「每日更新」与「追更提醒」深度结合：全站连载定时同步，你只需设置一次追更，
              之后每次更新都会第一时间通知你，真正实现打开就有新内容、追更更省心。
            </p>

            <div className="mt-8 space-y-4">
              {steps.map((s) => (
                <div key={s.title} className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4">
                  <span className="w-11 h-11 shrink-0 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center text-xl">
                    <i className={s.icon}></i>
                  </span>
                  <div>
                    <h3 className="font-medium text-foreground-950">{s.title}</h3>
                    <p className="mt-1 text-sm text-foreground-600">{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <a
              href="#subscribe"
              className="mt-8 inline-flex items-center whitespace-nowrap rounded-md bg-primary-500 text-background-50 px-6 py-3 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer"
            >
              立即开启追更提醒
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>

          <div className="rounded-xl overflow-hidden border border-background-200 bg-background-50 shadow-sm">
            <div className="relative w-full aspect-[16/10]">
              <img
                src={featured.cover}
                alt={`${featured.title}今日更新章节`}
                className="w-full h-full object-top object-cover"
              />
              <span className="absolute top-3 left-3 rounded-md bg-primary-500 text-background-50 text-xs px-2.5 py-1">本周人气榜 · 第1名</span>
            </div>
            <div className="p-5">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-xl text-foreground-950">{featured.title}</h3>
                <span className="inline-flex items-center gap-1 text-xs text-secondary-800 bg-secondary-100 rounded-full px-2.5 py-1">
                  <i className="ri-heart-3-fill text-primary-500"></i>{featured.followers.toLocaleString()} 人追更
                </span>
              </div>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{featured.desc}</p>
              <div className="mt-4 flex items-center gap-3 text-sm">
                <span className="inline-flex items-center gap-1 text-accent-700"><i className="ri-sparkling-line"></i>{featured.latestChapter}</span>
                <span className="text-foreground-400">|</span>
                <span className="text-foreground-600">更新于 {featured.updateTime}</span>
              </div>
              <div className="mt-4 flex flex-wrap gap-2">
                {featured.tags.map((t) => (
                  <span key={t} className="rounded-full bg-background-200 text-foreground-700 text-xs px-3 py-1">{t}</span>
                ))}
              </div>
              <a
                href="#updates"
                className="mt-5 inline-flex items-center whitespace-nowrap rounded-md border border-primary-300 text-primary-700 px-5 py-2.5 text-sm font-medium hover:bg-primary-100 transition-colors cursor-pointer"
              >
                <i className="ri-book-open-line mr-2"></i>开始追这部作品
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}